export default __webpack_public_path__ + "static/media/ic_arrow_right.35326940.svg";